import { useTranslation } from 'react-i18next';
import { formatToDate } from 'utils/formatToDate';

import { DocumentModel } from 'api/documents/documents.model';
import Detail from 'components/Detail';
import useCertificateHelper from 'hooks/useCertificateHelper';
import {
  ADDITIONAL_DETAILS,
  CertificateDetailsModel,
  NESTED_DETAILS,
} from 'models/certificate.model';

import RelatedDocument from '../RelatedDocument';
import Template from '../Template';

const BatteryCellsReceivingConfirmation = ({
  additionalDetails = {} as CertificateDetailsModel,
  ...document
}: DocumentModel<CertificateDetailsModel>) => {
  const { t } = useTranslation();

  const { getLabel } = useCertificateHelper();

  return (
    <Template
      document={{
        additionalDetails,
        ...document,
      }}
      rigthCard={
        <>
          <Detail
            label={getLabel(ADDITIONAL_DETAILS.RECEIVING_DATE)}
            value={formatToDate(additionalDetails[ADDITIONAL_DETAILS.RECEIVING_DATE])}
          />
          <Detail
            label={t('document.dateOfPublication')}
            value={formatToDate(document.publicationDate)}
          />
          <Detail
            label={getLabel(NESTED_DETAILS.BATTERY_CELL_MODEL)}
            value={additionalDetails[NESTED_DETAILS.BATTERY_CELL_MODEL]}
          />
          <RelatedDocument
            relatedDocumentProductId={additionalDetails[NESTED_DETAILS.BATTERY_CELLS_BATCH_NUMBER]}
          >
            <Detail
              label={getLabel(NESTED_DETAILS.BATTERY_CELLS_BATCH_NUMBER)}
              value={additionalDetails[NESTED_DETAILS.BATTERY_CELLS_BATCH_NUMBER]}
            />
          </RelatedDocument>
        </>
      }
    />
  );
};

export default BatteryCellsReceivingConfirmation;
